export default __webpack_public_path__ + "static/media/et.be6dcb0a.svg";